import React, {useEffect, useState} from "react"
import axios, { Axios } from 'axios'
import { useLocation } from 'react-router-dom';

export default function ChangePasswordSettingsGoogle() {

    const location = useLocation();

    const [passwordExists, setPasswordExists] = useState(3)
    
    useEffect(() => {
        const passwordExistsCheck = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND}/password_exists_check`);
            //console.log(response.data.exists);
            if (response.data.exists === 1) {
            setPasswordExists(1);
            } else if (response.data.exists === 0) {
            setPasswordExists(2);
            }
        } catch (error) {
            console.error("Error fetching password status:", error);
        }
        };
        passwordExistsCheck()
    }, [location.search]);

    const [passwordReg1, setPasswordReg1] = useState('')
    const [passwordReg2, setPasswordReg2] = useState('')
    const [passwordReg3, setPasswordReg3] = useState('')
    const [passwordError2, setPasswordError2] = useState('');
    const [passwordError3, setPasswordError3] = useState('');

    const [alertState, setAlertState] = useState(0)
    const [alertStateWrong, setAlertStateWrong] = useState(0)
    const [description, setDescription] = useState('')

    const validatePassword2 = (value) => {
        if (value.length > 30) {
            setPasswordError2('Password must be maximum 30 characters long');
            return false; // Password longer than 30 characters
        } else if (value.includes(' ')) {
            setPasswordError2('Password cannot contain spaces');
            return false;
        } else if (value.length < 8) {
            setPasswordError2('Password must be at least 8 characters long');
            return false;
        } else {
            setPasswordError2('');
            return true;
        }
    };

    const validatePassword3 = (value) => {
        if (value.length > 30) {
            setPasswordError3('Password must be maximum 30 characters long');
            return false; // Password longer than 30 characters
        } else if (value.includes(' ')) {
            setPasswordError3('Password cannot contain spaces');
            return false;
        } else if (value.length < 8) {
            setPasswordError3('Password must be at least 8 characters long');
            return false;
        } else {
            setPasswordError3('');
            return true;
        }
    };

    const changePasswordFunction =() => {
        
        axios.post(`${process.env.REACT_APP_BACKEND}/changePasswordGoogle`, {
            passwordOld: passwordReg1,
            passwordNew: passwordReg2,
            passwordNewRepeat: passwordReg3
        }).then((response) => {
            //alert(response.data.message)

            setAlertState(1);
            const descr = response.data.message
            setDescription(descr)
        }).catch((err) => {
            //alert(JSON.stringify(err.response.data.message))

            setAlertStateWrong(1);
            const descrWrong = err.response.data.message
            setDescription(descrWrong)
        })
      }

      const closeAlert =() => {
        setAlertState(0)
        setAlertStateWrong(0)
        setDescription('')
    }

    const restorePasswordLink =() => {
        window.location.href = `/restorepasswordrequest`;
      }

       const [passwordVisibleRegister, setPasswordVisibleRegister] = useState(false);
    
          const togglePasswordVisibilityRegister = () => {
            setPasswordVisibleRegister(!passwordVisibleRegister);
          };
      
    return (
        <>
            {passwordExists === 1 ? 
            <div className="changePasswordPage">
             <form className="formAccountChangePassword">  
             <div className="changeEmailFormColumn">
                <label className="labelChangePassword">Old password</label>

                <input type={passwordVisibleRegister ? "text" : "password"} className="buttonFormChangePassword"
                 onChange={(e) => {
                    setPasswordReg1(e.target.value)
                }}/>
            </div>

            <div className="changeEmailFormColumn">
                <label className="labelChangePassword">New password</label>

                <input type={passwordVisibleRegister ? "text" : "password"} className="buttonFormChangePassword"
                 onChange={(e) => {
                    setPasswordReg2(e.target.value)
                    validatePassword2(e.target.value);
                }}/>
                {passwordError2 && <span className="errorChangeEmail">{passwordError2}</span>}
            </div>

            <div className="changeEmailFormColumn">
                <label className="labelChangePassword">Repeat new password</label>

                <input type={passwordVisibleRegister ? "text" : "password"} className="buttonFormChangePassword"
                 onChange={(e) => {
                    setPasswordReg3(e.target.value)
                    validatePassword3(e.target.value);
                }}/>
                {passwordError3 && <span className="errorChangeEmail">{passwordError3}</span>}
            </div>

            <div className="showPasswordChangePassword">show password 
                   <button
                            type="button"
                            className="buttonShowPasswordRegisterChangePassword"
                            onClick={togglePasswordVisibilityRegister}
                        >
                        {passwordVisibleRegister ? 
                        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                        <path d="M3.17163 5.12988L21.1716 19.1299" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14.3653 13.8456C13.8162 14.5483 12.9609 15 12 15C10.3431 15 9 13.6569 9 12C9 11.3256 9.22253 10.7032 9.59817 10.2021" stroke="#323232" stroke-width="2"/>
                        <path d="M9 5.62667C11.5803 4.45322 14.7268 4.92775 16.8493 7.05025L19.8511 10.052C20.3477 10.5486 20.5959 10.7969 20.7362 11.0605C21.0487 11.6479 21.0487 12.3521 20.7362 12.9395C20.5959 13.2031 20.3477 13.4514 19.8511 13.948V13.948L19.799 14" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.01596 8.39827C7.40649 8.00774 7.40649 7.37458 7.01596 6.98406C6.62544 6.59353 5.99228 6.59353 5.60175 6.98406L7.01596 8.39827ZM7.65685 16.2427L5.53553 14.1213L4.12132 15.5356L6.24264 17.6569L7.65685 16.2427ZM16.1421 16.2427C13.799 18.5858 10 18.5858 7.65685 16.2427L6.24264 17.6569C9.36684 20.7811 14.4322 20.7811 17.5563 17.6569L16.1421 16.2427ZM5.53553 9.8787L7.01596 8.39827L5.60175 6.98406L4.12132 8.46449L5.53553 9.8787ZM16.7465 15.6383L16.1421 16.2427L17.5563 17.6569L18.1607 17.0526L16.7465 15.6383ZM5.53553 14.1213C4.84888 13.4347 4.40652 12.9893 4.12345 12.6183C3.85798 12.2704 3.82843 12.1077 3.82843 12L1.82843 12C1.82843 12.7208 2.1322 13.3056 2.53341 13.8315C2.917 14.3342 3.47464 14.8889 4.12132 15.5356L5.53553 14.1213ZM4.12132 8.46449C3.47464 9.11116 2.917 9.6658 2.53341 10.1686C2.1322 10.6944 1.82843 11.2792 1.82843 12H3.82843C3.82843 11.8924 3.85798 11.7297 4.12345 11.3817C4.40652 11.0107 4.84888 10.5654 5.53553 9.8787L4.12132 8.46449Z" fill="#323232"/>
                        </svg>
                         :
                         <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                         <path fill-rule="evenodd" clip-rule="evenodd" d="M6.30147 15.5771C4.77832 14.2684 3.6904 12.7726 3.18002 12C3.6904 11.2274 4.77832 9.73158 6.30147 8.42294C7.87402 7.07185 9.81574 6 12 6C14.1843 6 16.1261 7.07185 17.6986 8.42294C19.2218 9.73158 20.3097 11.2274 20.8201 12C20.3097 12.7726 19.2218 14.2684 17.6986 15.5771C16.1261 16.9282 14.1843 18 12 18C9.81574 18 7.87402 16.9282 6.30147 15.5771ZM12 4C9.14754 4 6.75717 5.39462 4.99812 6.90595C3.23268 8.42276 2.00757 10.1376 1.46387 10.9698C1.05306 11.5985 1.05306 12.4015 1.46387 13.0302C2.00757 13.8624 3.23268 15.5772 4.99812 17.0941C6.75717 18.6054 9.14754 20 12 20C14.8525 20 17.2429 18.6054 19.002 17.0941C20.7674 15.5772 21.9925 13.8624 22.5362 13.0302C22.947 12.4015 22.947 11.5985 22.5362 10.9698C21.9925 10.1376 20.7674 8.42276 19.002 6.90595C17.2429 5.39462 14.8525 4 12 4ZM10 12C10 10.8954 10.8955 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8955 14 10 13.1046 10 12ZM12 8C9.7909 8 8.00004 9.79086 8.00004 12C8.00004 14.2091 9.7909 16 12 16C14.2092 16 16 14.2091 16 12C16 9.79086 14.2092 8 12 8Z" fill="#000000"/>
                         </svg> }  </button>
            </div>

                <button type="button" onClick={() => {changePasswordFunction()}} className="buttonFormSubmitChangeEmail" disabled={passwordError2 || passwordError3}>Change password</button>
            </form>

            <div className={alertState ? 'alertDiv' : 'notDisplayed' }>
  
            <div className="alertDiv-content">
                <i className="check">

                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24" fill="none">
                <path d="M4.89163 13.2687L9.16582 17.5427L18.7085 8" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path xmlns="http://www.w3.org/2000/svg" d="M4.89163 13.2687L9.16582 17.5427L18.7085 8" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </i>

                <div className="messageDiv">
                <span className="textDiv textDiv-1">Success</span>
                <span className="textDiv textDiv-2">{description}</span>
                </div>
            </div>
            <button className="close" onClick={() => {closeAlert()}}>X</button>

            </div>

            <div className={alertStateWrong ? 'alertDiv' : 'notDisplayed' }>

            <div className="alertDiv-content">
                <i className="checkWrong">

                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24" fill="none">
                <path d="M6 12L18 12" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </i>

                <div className="messageDiv">
                <span className="textDiv textDiv-1">Ops</span>
                <span className="textDiv textDiv-2">{description}</span>
                </div>
            </div>
            <button className="close" onClick={() => {closeAlert()}}>X</button>

            </div>
            <div className="recoverPasswordChangePasswordPage">Forgot password? You can <span className="recoverPasswordChangePasswordPageSpan" onClick={() => {restorePasswordLink()}}>restore</span> it with your email</div>
        </div>
        
        :

        <div className="changePasswordPage">
             <form className="formAccountChangePassword">  

            <div className="changeEmailFormColumn">
                <label className="labelChangePassword">New password</label>

                <input type={passwordVisibleRegister ? "text" : "password"} className="buttonFormChangePassword"
                 onChange={(e) => {
                    setPasswordReg2(e.target.value)
                    validatePassword2(e.target.value);
                }}/>
                {passwordError2 && <span className="errorChangeEmail">{passwordError2}</span>}
            </div>

            <div className="changeEmailFormColumn">
                <label className="labelChangePassword">Repeat new password</label>

                <input type={passwordVisibleRegister ? "text" : "password"} className="buttonFormChangePassword"
                 onChange={(e) => {
                    setPasswordReg3(e.target.value)
                    validatePassword3(e.target.value);
                }}/>
                {passwordError3 && <span className="errorChangeEmail">{passwordError3}</span>}
            </div>

            <div className="showPasswordChangePasswordNewPassword">show password 
                   <button
                            type="button"
                            className="buttonShowPasswordRegisterChangePassword"
                            onClick={togglePasswordVisibilityRegister}
                        >
                        {passwordVisibleRegister ? 
                        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                        <path d="M3.17163 5.12988L21.1716 19.1299" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14.3653 13.8456C13.8162 14.5483 12.9609 15 12 15C10.3431 15 9 13.6569 9 12C9 11.3256 9.22253 10.7032 9.59817 10.2021" stroke="#323232" stroke-width="2"/>
                        <path d="M9 5.62667C11.5803 4.45322 14.7268 4.92775 16.8493 7.05025L19.8511 10.052C20.3477 10.5486 20.5959 10.7969 20.7362 11.0605C21.0487 11.6479 21.0487 12.3521 20.7362 12.9395C20.5959 13.2031 20.3477 13.4514 19.8511 13.948V13.948L19.799 14" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.01596 8.39827C7.40649 8.00774 7.40649 7.37458 7.01596 6.98406C6.62544 6.59353 5.99228 6.59353 5.60175 6.98406L7.01596 8.39827ZM7.65685 16.2427L5.53553 14.1213L4.12132 15.5356L6.24264 17.6569L7.65685 16.2427ZM16.1421 16.2427C13.799 18.5858 10 18.5858 7.65685 16.2427L6.24264 17.6569C9.36684 20.7811 14.4322 20.7811 17.5563 17.6569L16.1421 16.2427ZM5.53553 9.8787L7.01596 8.39827L5.60175 6.98406L4.12132 8.46449L5.53553 9.8787ZM16.7465 15.6383L16.1421 16.2427L17.5563 17.6569L18.1607 17.0526L16.7465 15.6383ZM5.53553 14.1213C4.84888 13.4347 4.40652 12.9893 4.12345 12.6183C3.85798 12.2704 3.82843 12.1077 3.82843 12L1.82843 12C1.82843 12.7208 2.1322 13.3056 2.53341 13.8315C2.917 14.3342 3.47464 14.8889 4.12132 15.5356L5.53553 14.1213ZM4.12132 8.46449C3.47464 9.11116 2.917 9.6658 2.53341 10.1686C2.1322 10.6944 1.82843 11.2792 1.82843 12H3.82843C3.82843 11.8924 3.85798 11.7297 4.12345 11.3817C4.40652 11.0107 4.84888 10.5654 5.53553 9.8787L4.12132 8.46449Z" fill="#323232"/>
                        </svg>
                         :
                         <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                         <path fill-rule="evenodd" clip-rule="evenodd" d="M6.30147 15.5771C4.77832 14.2684 3.6904 12.7726 3.18002 12C3.6904 11.2274 4.77832 9.73158 6.30147 8.42294C7.87402 7.07185 9.81574 6 12 6C14.1843 6 16.1261 7.07185 17.6986 8.42294C19.2218 9.73158 20.3097 11.2274 20.8201 12C20.3097 12.7726 19.2218 14.2684 17.6986 15.5771C16.1261 16.9282 14.1843 18 12 18C9.81574 18 7.87402 16.9282 6.30147 15.5771ZM12 4C9.14754 4 6.75717 5.39462 4.99812 6.90595C3.23268 8.42276 2.00757 10.1376 1.46387 10.9698C1.05306 11.5985 1.05306 12.4015 1.46387 13.0302C2.00757 13.8624 3.23268 15.5772 4.99812 17.0941C6.75717 18.6054 9.14754 20 12 20C14.8525 20 17.2429 18.6054 19.002 17.0941C20.7674 15.5772 21.9925 13.8624 22.5362 13.0302C22.947 12.4015 22.947 11.5985 22.5362 10.9698C21.9925 10.1376 20.7674 8.42276 19.002 6.90595C17.2429 5.39462 14.8525 4 12 4ZM10 12C10 10.8954 10.8955 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8955 14 10 13.1046 10 12ZM12 8C9.7909 8 8.00004 9.79086 8.00004 12C8.00004 14.2091 9.7909 16 12 16C14.2092 16 16 14.2091 16 12C16 9.79086 14.2092 8 12 8Z" fill="#000000"/>
                         </svg> }  </button>
            </div>

                <button type="button" onClick={() => {changePasswordFunction()}} className="buttonFormSubmitChangeEmail" disabled={passwordError2 || passwordError3}>Change password</button>
            </form>

            <div className={alertState ? 'alertDiv' : 'notDisplayed' }>
  
            <div className="alertDiv-content">
                <i className="check">

                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24" fill="none">
                <path d="M4.89163 13.2687L9.16582 17.5427L18.7085 8" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path xmlns="http://www.w3.org/2000/svg" d="M4.89163 13.2687L9.16582 17.5427L18.7085 8" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </i>

                <div className="messageDiv">
                <span className="textDiv textDiv-1">Success</span>
                <span className="textDiv textDiv-2">{description}</span>
                </div>
            </div>
            <button className="close" onClick={() => {closeAlert()}}>X</button>

            </div>

            <div className={alertStateWrong ? 'alertDiv' : 'notDisplayed' }>

            <div className="alertDiv-content">
                <i className="checkWrong">

                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24" fill="none">
                <path d="M6 12L18 12" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </i>

                <div className="messageDiv">
                <span className="textDiv textDiv-1">Ops</span>
                <span className="textDiv textDiv-2">{description}</span>
                </div>
            </div>
            <button className="close" onClick={() => {closeAlert()}}>X</button>

            </div>
            <div className="recoverPasswordChangePasswordPage">Forgot password? You can <span className="recoverPasswordChangePasswordPageSpan" onClick={() => {restorePasswordLink()}}>restore</span> it with your email</div>
        </div>}
        </> 
    )
}